import React from 'react' 
import NavigationHeder from '../../Navigations/NavigationHeder';
import AgGridNew from '../../grid/ag/ag-grid-new'; 
import MasterComponentWraper from '../../Backend/MasterComponentWraper'; 
import Settings from '../../../inc/Settings';
import DatepickerFunctions from '../../../inc/DatepickerHelper';
import { getLabelFromDropdown } from '../../grid/ag/commonFunctions/GridCommonFunctions';
import SimpleDropdown from '../../grid/ag/cellEditor/SimpleDropdown';

let gridApi = null;
const TenantFormsListings = () => {
  const gridColumnHeaders = [
    {field:'tenant_name', filter: 'agTextColumnFilter', headerName:'Tenant name', editable:false },
    {field:'tenant_code', headerName:'Tenant code', editable: false }, 
    {field:'registration_date', valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateFromDataBase(params?.value) : '-', headerName:'Registration date', editable: false }, 
    {field:'expiry_date', valueFormatter: (params) => params?.value ? DatepickerFunctions.convertDateFromDataBase(params?.value) : '-', headerName:'Expiry date', editable: false },
    {
      field: 'status',
      headerName: 'Status',
      editable: false, 
      isAllowZero:true,
      cellEditor: SimpleDropdown,
      minWidth:180,  
      cellEditorParams: {
        values: Settings.enumStatus
      },
      cellDataType:false,
      valueFormatter: (params) => getLabelFromDropdown(params)
    } 
  ];

  return (
    <div className='container-fluid'>
      <NavigationHeder hideMoreBtn={true} backUrl='/system-integration' title={'Tenant'}></NavigationHeder>
  
      <AgGridNew
        apiUrl={Settings.apiAppUrl+`/tenant/`} 
        pagination={false}
        columnDefs={gridColumnHeaders} 
        hideDeleteBtn={true}
        hideAddBtn={true}
        height={500}
        uniqueField={'tenant_id'} 
        onGridReady={(params) => gridApi = params?.api} 
        gridId={"tenant_forms_listing_grid"}
      />
    </div> 
  )
};

export default (MasterComponentWraper(TenantFormsListings));